import { useState } from "react";
import styles from "./forgot-password.module.css";
import LanguageSelector from "components/functional/language-selector";
import { useTranslation } from "react-i18next";
import Spinner from "components/functional/spinner";
import instance from "services/api";
import { ToastComponent, ToastService } from "services/toast.service";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [mailSent, setMailSent] = useState(false);

  const navigate = useNavigate();
  const sendResetPasswordLink = async () => {
    if (!email) {
      setError(true);
      return;
    }

    setLoading(true);
    try {
      await instance.post("/password", { email });
      setMailSent(true);
    } catch (error) {
      if (error.response?.data?.error_code === "USER_NOT_FOUND") {
        setMailSent(true);
      } else {
        ToastService.showErrorToast(t("toast.forgot-password-error"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <ToastComponent />
      <div className={styles.container}>
        <header className={`${styles.header} mb-48`}>
          <img src="/logo.png" width="40" height="38" alt="" />
          {!mailSent && <LanguageSelector />}
        </header>
        {!mailSent ? (
          <section className={styles.content}>
            <div className={styles.description}>
              <h1 className="title-1">{t("forgot-password.title")}</h1>
              <p className="subtitle-1-variant">
                {t("forgot-password.description")}
              </p>
            </div>
            <div className="form-group">
              <label htmlFor="email" className="required">
                {t("parameters.profile.form.email")}
              </label>
              <input
                type="email"
                autoComplete="username"
                required
                id="email"
                value={email}
                placeholder={t("parameters.profile.form.email-placeholder")}
                data-testid="email-input"
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError(false);
                }}
                className={error && "error"}
              />
              {error && <p className="error-message">{t("errors.required")}</p>}
            </div>
            <div className={styles.actions}>
              <button
                className="btn btn--secondary"
                onClick={() => navigate("/login")}
              >
                <ChevronLeft size={20} />
                <p className="subtitle-1-variant">{t("actions.back")}</p>
              </button>
              <button
                onClick={sendResetPasswordLink}
                data-testid="reset-password-button"
                className={`btn btn--primary ${styles.button}`}
              >
                {t("forgot-password.button")}
                {loading && <Spinner className="action-loader" />}
              </button>
            </div>
          </section>
        ) : (
          <section className={styles.content}>
            <div className={styles.description}>
              <h1 className="title-1">
                {t("forgot-password.mail-sent.title")}
              </h1>
              <p className="subtitle-1-variant">
                {t("forgot-password.mail-sent.description")}
              </p>
            </div>
            <button
              className="btn btn--primary"
              onClick={() => navigate("/login")}
            >
              {t("actions.sign-in")}
            </button>
          </section>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
